import { defineComponent, ref, computed } from 'vue';
import TransitionExpand from '../../../../../transitions/TransitionExpand/TransitionExpand.js';
import __vue_component__ from '../../../../../ui/Icon.vue.js';
import __vue_component__$1 from '../../../../../ui/Tooltip/Tooltip.vue.js';
import '@caresend/utils';
import '@caresend/types';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import { copyToClipboard } from '../../../../../../functions/clipboard.js';
import { getSeededColor, mutateColorBrightness } from '../../../../../../functions/color.js';
import '../../../../../../functions/configuration/icons.js';
import '../../../../../../database/algoliaConfig/indices.js';
import { preventParentClickAndDefault } from '../../../../../../functions/preventDefault.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';

var script = defineComponent({
    name: 'ExpandCopyID',
    components: {
        Icon: __vue_component__,
        Tooltip: __vue_component__$1,
        TransitionExpand,
    },
    props: {
        id: {
            type: String,
            default: undefined,
        },
        entityName: {
            type: String,
            default: 'Waypoint',
        },
        allowExpand: {
            type: Boolean,
            default: false,
        },
        dark: {
            type: Boolean,
            default: false,
        },
        useSeededColor: {
            type: Boolean,
            default: false,
        },
        extraSeed: {
            type: String,
            default: '',
        },
        /** Use negative number to start from the end of the string */
        substring: {
            type: Number,
            default: null,
        },
    },
    setup(props) {
        const labelExpanded = ref(!props.allowExpand);
        const copyID = () => {
            if (!props.id)
                return;
            copyToClipboard(props.id, `${props.entityName} ID copied to clipboard`, `Failed to copy ${props.entityName} ID`);
        };
        const idSubstring = computed(() => {
            if (props.substring === 0 || !props.id)
                return '';
            if (props.substring) {
                if (props.substring > 0) {
                    return props.id.substring(0, props.substring);
                }
                return props.id.substring(props.substring);
            }
            return props.id;
        });
        const className = props.dark ? 'ExpandCopyID--dark' : 'ExpandCopyID';
        const style = computed(() => {
            if (props.useSeededColor) {
                const color = getSeededColor(props.extraSeed + props.id);
                return {
                    backgroundColor: `${mutateColorBrightness(color, -20)} !important`,
                    opacity: '0.7',
                    color: 'white !important',
                };
            }
            return {};
        });
        const tooltipLabel = computed(() => `Copy ${(props.substring !== null) ? 'full' : ''} ${props.entityName.toLowerCase()} ID`);
        return {
            className,
            copyID,
            idSubstring,
            labelExpanded,
            preventParentClickAndDefault,
            style,
            tooltipLabel,
        };
    },
});

export { script as default };
